import $ from 'jquery';

import createBehavior from '../create-behavior';


export default () => {
  class PlanningCommunications {
    constructor($el, context, settings) {
      let promoType = $el.find('.promo-type-ttl');
      let promoTypeChild = $el.find('.promo-type-child');
      let promoDay = $el.find('.day');


      promoType.each( function () {
        let promoTypeHeight = $(this).outerHeight();
        let promoName =  $(this).find('.promo-type-name');
        promoName.css('height', promoTypeHeight);
      });

      promoTypeChild.each( function () {
        let promoTypeChildHeight = $(this).outerHeight();
        let promoTypeChildHolder =  $(this).find('.promo-type-child-holder');
        promoTypeChildHolder.css('height', promoTypeChildHeight);
      });

      promoDay.each( function () {
        let dayEventWidth = $(this).find('.event-holder').width();
        let dayPoipin = $(this).find('.popin');

        if (dayEventWidth > 248) {
          dayPoipin.addClass('large-event');
        }
      });
    }
  }

  createBehavior('.pc-dashboard table', 'PlanningCommunications', PlanningCommunications);
}




// WEBPACK FOOTER //
// ./js/src/behaviors/planning-communication.js